module.exports = __webpack_public_path__ + "img/signed.ac0ee4ea.png";